import { apiGet } from './client';

export function fetchCategories({ includeProducts = false } = {}) {
  const params = includeProducts ? { include_products: 1 } : {};
  return apiGet('/categories', params);
}

export function fetchProduct(slugOrId) {
  return apiGet(`/products/${encodeURIComponent(slugOrId)}`);
}

export async function fetchProductsPage(params = {}) {
  return apiGet('/products', params);
}

export async function fetchAllProducts(params = {}) {
  const perPage = 100;
  let page = 1;
  let items = [];
  let lastPage = 1;

  do {
    const paginator = await fetchProductsPage({ ...params, per_page: perPage, page });
    items = items.concat(paginator.data || []);
    lastPage = paginator.last_page || 1;
    page += 1;
  } while (page <= lastPage);

  return items;
}
